<template>
  <div class="immobile flex flex-wrap -mx-2 md:-mx-8 prose">
    <div class="w-full md:w-2/3 px-2 md:px-8 pt-8 overflow-hidden">
      <div class="flex flex-wrap justify-between items-stretch">
        <div class="flex-initial">
          <div class="immobile__title">
            <h2 class="text-2xl font-bold leading-tight">
              <span v-if="currentImmobile.TipologiaOfferta"
              >{{ currentImmobile.TipologiaOfferta.Voce }}
              </span>
              <span v-if="currentImmobile.TipologiaOffertaSubordinata"
              >{{ currentImmobile.TipologiaOffertaSubordinata.Voce }}
              </span>
              <span v-if="currentImmobile.Quartiere"
              >- {{ currentImmobile.Quartiere.Denominazione }}</span
              >
            </h2>
            <h4 class="text-xl leading-tight">
              <span v-if="currentImmobile.TrattativaRiservata"
              >Trattativa Riservata</span
              >
              <span v-else>{{ prezzo | currency }}</span>
            </h4>
            <h4 class="text-xl leading-tight">
              {{ currentImmobile.ComuneWeb }}
            </h4>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 mt-5 mb-10">
        <div v-if="videos && videos.length" class="w-1/4 px-2">
          <button @click="gallery='video'"
                  :class="['px-4 py-2 text-xs md:text-base border w-full inline-flex flex-col md:flex-row justify-center items-center space-y-1 md:space-y-0 space-x-1', {'bg-blue-500 text-white': gallery === 'video'}]">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
            </svg>
            <span>Video</span></button>
        </div>
        <div v-if="attachments && attachments.length" class="w-1/4 px-2">
          <button @click="gallery='foto'"
                  :class="['px-4 py-2 text-xs md:text-base border w-full inline-flex flex-col md:flex-row justify-center items-center space-y-1 md:space-y-0 space-x-1', {'bg-blue-500 text-white': gallery === 'foto'}]">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
            <span>Foto</span>
          </button>
        </div>

        <div v-if="planimetrie && planimetrie.length" class="w-1/4 px-2">
          <button @click="gallery = 'planimetrie'"
                  :class="['px-4 py-2 text-xs md:text-base border w-full inline-flex flex-col md:flex-row justify-center items-center space-y-1 md:space-y-0 space-x-1', {'bg-blue-500 text-white': gallery === 'planimetrie'}]">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
            <span>Planimetrie</span>
          </button>
        </div>

        <div v-if="coords" class="w-1/4 px-2">
          <button @click="gallery = 'mappa'"
                  :class="['px-4 py-2 text-xs md:text-base border w-full inline-flex flex-col md:flex-row justify-center items-center space-y-1 md:space-y-0 space-x-1', {'bg-blue-500 text-white': gallery === 'mappa'}]">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"></path></svg>
            <span>Mappa</span>
          </button>
        </div>
      </div>

      <div class="min-h-300 md:min-h-500">
        <div v-show="gallery === 'video'" v-if="videos.length" class="w-full">
          <div
              v-for="(video, index) in videos"
              class="mb-8 responsive-embed"
              :key="index"
          >
            <iframe
                width="560"
                height="315"
                :src="`https://www.youtube-nocookie.com/embed/${video.id}`"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
          </div>
        </div>
        <gallery v-show="gallery === 'foto'" :commons="commons" :attachments="attachments"/>
        <gallery v-show="gallery === 'planimetrie'" :commons="commons" :attachments="planimetrie"/>
        <div v-if="coords && gallery === 'mappa'" class="immobile__map w-full">
          <h3>Mappa:</h3>
          <div class="immobile__map-wrapper">
            <mappa :coords="coords"/>
          </div>
        </div>
      </div>

      <ul v-if="plans.length" class="planimetrie flex flex-wrap -mx-4">
        <li
            v-for="(plan, index) in plans"
            :key="index"
            class="mt-4 mb-10 w-full md:w-1/2 px-4"
        >
          <a
              class="block border p-4"
              :href="commons.attachmentSrc(plan.IDPubblico)"
              target="_blank"
          >
            <i class="float-left mr-2 mt-1">
              <svg
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="cloud-download w-6 h-6 text-gray-500"
              >
                <path
                    fill-rule="evenodd"
                    d="M2 9.5A3.5 3.5 0 005.5 13H9v2.586l-1.293-1.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 10-.616-8.958 4.002 4.002 0 10-7.753 1.977A3.5 3.5 0 002 9.5zm9 3.5H9V8a1 1 0 012 0v5z"
                    clip-rule="evenodd"
                ></path>
              </svg>
            </i>
            <span class="text-xl font-light">Planimetria</span>
          </a>
        </li>
      </ul>

      <div class="immobile__info flex flex-wrap mb-8 md:mb-16">
        <div class="w-full">
          <h3>Dettagli:</h3>
        </div>
        <div class="w-full">
          <ul class="flex flex-wrap -mx-4">
            <li class="w-full md:w-1/2 px-4">
              <strong>Contratto:</strong> {{ contratto }}
            </li>
            <li
                class="w-full md:w-1/2 px-4"
                v-if="currentImmobile.TrattativaRiservata"
            >
              <strong>Prezzo:</strong>
              Trattativa Riservata
            </li>
            <li class="w-full md:w-1/2 px-4" v-else>
              <strong>Prezzo:</strong> {{ prezzo | currency }}
            </li>
            <li
                v-if="currentImmobile.SpeseCondominiali"
                class="w-full md:w-1/2 px-4"
            >
              <strong>Spese Condominiali:</strong>
              {{ currentImmobile.SpeseCondominiali | currency }}
            </li>
            <li v-if="currentImmobile.StatoConservazioneEdificio"
                class="w-full md:w-1/2 px-4">
              <strong>Stato conservazione edificio:</strong>
              {{currentImmobile.StatoConservazioneEdificio.Voce}}
            </li>
            <li v-if="currentImmobile.AnnoCostruzioneEdificio"
                class="w-full md:w-1/2 px-4">
              <strong>Anno costruzione edificio:</strong>
              {{currentImmobile.AnnoCostruzioneEdificio}}
            </li>
            <li v-if="currentImmobile.AnnoUltimeRistrutturazioneEdificio"
                class="w-full md:w-1/2 px-4">
              <strong>Ultima ristrutturazione edificio:</strong>
              {{currentImmobile.AnnoUltimeRistrutturazioneEdificio}}
            </li>
            <li v-if="currentImmobile.TipoStatoConservazioneImmobile"
                class="w-full md:w-1/2 px-4">
              <strong>Stato conservazione immobile:</strong>
              {{currentImmobile.TipoStatoConservazioneImmobile.Voce}}
            </li>
            <li v-if="currentImmobile.AnnoUltimaRistrutturazioneImmobile"
                class="w-full md:w-1/2 px-4">
              <strong>Ultima ristrutturazione immobile:</strong>
              {{currentImmobile.AnnoUltimaRistrutturazioneImmobile}}
            </li>
            <li
                v-if="currentImmobile.MqPredefiniti"
                class="w-full md:w-1/2 px-4"
            >
              <strong>Superficie:</strong>
              {{ currentImmobile.MqPredefiniti }} m<sup>2</sup>
            </li>
            <li v-if="currentImmobile.NLocali" class="w-full md:w-1/2 px-4">
              <strong>Locali:</strong>
              {{ currentImmobile.NLocali }}
            </li>
            <li
                v-if="currentImmobile.NCamereTotali"
                class="w-full md:w-1/2 px-4"
            >
              <strong>Camere:</strong>
              {{ currentImmobile.NCamereTotali }}
            </li>
            <li
                v-if="currentImmobile.NBagniTotali"
                class="w-full md:w-1/2 px-4"
            >
              <strong>Bagni:</strong>
              {{ currentImmobile.NBagniTotali }}
            </li>
            <li v-if="terrazzo" class="w-full md:w-1/2 px-4">
              <strong>Terrazzo Abitabile:</strong>
              {{ terrazzo }}
            </li>
            <li class="w-full md:w-1/2 px-4">
              <strong>Garage:</strong> {{ garage }}
            </li>
            <li v-if="currentImmobile.NPostiAutoCopertiPrivati > 0" class="w-full md:w-1/2 px-4">
              <strong>Posti Auto Coperti Privati:</strong> {{ currentImmobile.NPostiAutoCopertiPrivati }}
            </li>
            <li v-if="currentImmobile.NPostiAutoScopertiPrivati > 0" class="w-full md:w-1/2 px-4">
              <strong>Posti Auto Scoperti Privati:</strong> {{ currentImmobile.NPostiAutoScopertiPrivati }}
            </li>
            <li v-if="currentImmobile.NPostiAutoCopertiCondominiali > 0" class="w-full md:w-1/2 px-4">
              <strong>Posti Auto Coperti Condominiali:</strong> {{ currentImmobile.NPostiAutoCopertiCondominiali }}
            </li>
            <li v-if="currentImmobile.NPostiAutoScopertiCondominiali > 0" class="w-full md:w-1/2 px-4">
              <strong>Posti Auto Scoperti Condominiali:</strong> {{ currentImmobile.NPostiAutoScopertiCondominiali }}
            </li>
            <li
                v-if="currentImmobile.TipoGiardino"
                class="w-full md:w-1/2 px-4"
            >
              <strong>Giardino:</strong>
              {{ currentImmobile.TipoGiardino.Voce }}
            </li>
            <li
                v-if="currentImmobile.ID_TipologiaCucina"
                class="w-full md:w-1/2 px-4"
            >
              <strong>Tipologia Cucina:</strong>
              {{ currentImmobile.TipologiaCucina.Voce }}
            </li>
            <li v-if="currentImmobile.NBalconi" class="w-full md:w-1/2 px-4">
              <strong>Numero balconi:</strong> {{ currentImmobile.NBalconi }}
            </li>
            <li v-if="currentImmobile.MqBalconi" class="w-full md:w-1/2 px-4">
              <strong
              >Superficie balconi: {{ currentImmobile.MqBalconi }}</strong
              >
            </li>
          </ul>
        </div>

        <div style="white-space: pre-line" class="immobile__desc mb-8 md:mb-16" v-html="currentImmobile.DescrizionePredefinita ">
        </div>

        <div class="w-full mb-8 md:mb-16">
          <div class="font-light text-4xl mb-4">
            <h2 class="text-2xl font-bold leading-none">Servizi</h2>
            <h4 class="text-xl leading-none">Informazioni extra</h4>
          </div>

          <services :current-immobile="currentImmobile"/>
        </div>

        <div id="consistenze" class="w-full mb-8 md:mb-16"
             v-if="currentImmobile.Consistenze && currentImmobile.Consistenze.length">
          <div class="font-light text-4xl mb-4">
            <h2 class="text-2xl font-bold leading-none">Dettaglio delle superfici</h2>
            <!--            <h4 class="text-xl leading-none">Consistenze</h4>-->
          </div>

          <consistenze :consistenze="currentImmobile.Consistenze"/>
        </div>

        <div id="caratteristiche" class="w-full  md:mb-16"
             v-if="currentImmobile.Caratteristiche.length">
          <div class="font-light text-4xl mb-4">
            <h2 class="text-2xl font-bold leading-none">Dettaglio delle finiture</h2>
            <!--            <h4 class="text-xl leading-none">Consistenze</h4>-->
          </div>

          <caratteristiche v-if="currentImmobile.Caratteristiche.length"
                           :consistenze="currentImmobile.Caratteristiche"/>
        </div>

        <modal v-if="modalVisibile" v-on:close="closeModal">
          <div class="font-light text-4xl mb-4">
            <h2 class="text-2xl font-bold leading-none">Consistenze</h2>
            <h4 class="text-xl leading-none">lorem ipsum</h4>
          </div>
          <consistenze v-if="currentImmobile.Consistenze && currentImmobile.MostraConsistenze"
                       :consistenze="currentImmobile.Consistenze"/>
        </modal>

        <div :class="{ hidden: distances === 0 }" class="w-full md:mb-16">
          <div class="font-light text-4xl mb-8">
            <h2 class="text-2xl font-bold leading-none">
              Distanza dai principali servizi
            </h2>
            <h4 class="text-xl leading-none">Informazioni extra</h4>
          </div>

          <div class="flex flex-wrap py-10 bg-gray-200 rounded">
            <distance
                v-if="currentImmobile.DistanzaCentro"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaCentro'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaNegozi"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaNegozi'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaParcheggio"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaParcheggio'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaAutobus"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaAutobus'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaMetropolitana"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaMetropolitana'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaStazioneFerroviaria"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaStazioneFerroviaria'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaAeroporto"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaAeroporto'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaPorto"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaPorto'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaCaselloAutostradale"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaCaselloAutostradale'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaMare"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaMare'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaLago"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaLago'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaImpiantiScii"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaImpiantiScii'"
                :current-immobile="currentImmobile"
            />
            <distance
                v-if="currentImmobile.DistanzaTerme"
                v-on:distance-exists="updateDistances"
                :property="'DistanzaTerme'"
                :current-immobile="currentImmobile"
            />
          </div>
        </div>
      </div>
    </div>
    <sidebar
        :agency="agency"
        :plans="plans"
        :commons="commons"
        :current-immobile="currentImmobile"
        v-on:scrollTo="scrollTo"
    />

  </div>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import Gallery from "./Gallery";
import Sidebar from "./Sidebar";
import Services from "./Services";
import Mappa from "./Mappa";
import Distance from "@/components/Distance";
import Consistenze from "@/components/Consistenze";
import Modal from "@/components/Modal";
import Caratteristiche from "@/components/Caratteristiche";

export default {
  name: "immobile",
  components: {
    Caratteristiche,
    Modal,
    Consistenze,
    Distance,
    Mappa,
    Services,
    Sidebar,
    Gallery,
  },
  props: {
    currentImmobile: {},
    attachments: {},
    planimetrie: {},
    commons: {},
    videos: {},
    plans: {},
    agency: {},
    hasVideo: {}
  },
  data(instance) {
    return {
      accessToken:
          "pk.eyJ1IjoibWFyY29tZXNzYSIsImEiOiJja2I5M2dnOHUwYTZvMnZqcGV3ajQ0aWpyIn0.IMfxyO3yhf296q3ncZ0t9Q",
      mapStyle: "mapbox://styles/mapbox/streets-v11",
      distances: 0,
      modalVisibile: false,
      gallery: instance.hasVideo ? 'video' : 'foto'
    };
  },

  computed: {
    contratto() {
      return this.currentImmobile.InVendita ? "Vendita" : "Affitto";
    },
    prezzo() {
      return this.contratto === "Vendita"
          ? this.currentImmobile.PrezzoVendita
          : this.currentImmobile.PrezzoLocazione;
    },
    terrazzo() {
      return this.currentImmobile.TerrazzoAbitabile ? "Sì" : false;
    },
    garage() {
      return this.currentImmobile.Garage ? "Sì" : "No";
    },
    coords() {
      if (this.currentImmobile.PosizioneGPSWeb) {
        const regex = /[+-]?\d+(\.\d+)?/g;
        let str = this.currentImmobile.PosizioneGPSWeb.Geography.WellKnownText;
        str = str.match(regex).map(function (v) {
          return parseFloat(v);
        });
        return [str[0], str[1]];
      } else {
        return false;
      }
    },
  },
  methods: {
    updateDistances() {
      this.distances++;
    },
    scrollTo() {
      const a = document.createElement('a');
      a.href = '#consistenze'
      a.click()
      /*this.modalVisibile = !this.modalVisibile*/
    },
    closeModal() {
      this.modalVisibile = false
    },
  },
};
</script>
<style lang="scss" scoped>
.immobile {
  &__title {
    @apply font-light text-4xl mb-4 pl-2 border-l-8 border-blue-500;
  }

  &__price {
    @apply text-3xl font-bold mb-5;
    @screen md {
      @apply mb-0;
    }
  }

  &__image {
    @apply mb-8;
  }

  &__desc {
    @apply font-light text-lg leading-relaxed mb-8 text-justify;
  }

  &__info {
    h3 {
      @apply text-2xl font-bold mb-4;
    }

    ul {
      @apply mb-8;
      li {
        @apply font-light text-lg leading-relaxed;
        strong {
          @apply font-bold;
        }
      }
    }
  }

  &__map {
    @apply mb-8;
    h3 {
      @apply text-2xl font-bold mb-4;
    }
  }

  &__map-wrapper {
    height: 400px;
  }
}

.responsive-embed {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
